// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
    @font-face {
      font-family: 'Open Sans';
      font-weight: bold;
      font-style: normal;
    }

    * {
      margin: 0;
      padding: 0;
      outline: 0;
    }

    html {
      min-width: 320px;
      background: #30333C;
      font-size: 14px;
      line-height: 1.375;
      font-family: "Open Sans", "Helvetica Neue", sans-serif;
    }

    body {
      color: #ffffff;
    }

    a {
      /*color: #78f4ff;*/
      text-decoration: none;
    }

    p {
      font-size: 16px;
      margin-bottom: 16px;
    }

    .container {
      width: 100%;
      margin-right: auto;
      margin-left: auto;
    }

    @media (min-width: 576px) {
      .container {
        max-width: 540px;
      }
    }

    @media (min-width: 768px) {
      .container {
        max-width: 720px;
      }
    }

    @media (min-width: 992px) {
      .container {
        max-width: 960px;
      }
    }

    @media (min-width: 1200px) {
      .container {
        max-width: 1140px;
      }
    }

    .header {
      padding: 24px 16px;
      margin-top: 32px;
    }

    .header__title {
      font-size: 24px;
      font-weight: bold;
    }

    @media (min-width: 768px) {
      .header__title {
        font-size: 28px;
      }
    }

    .section {
      position: relative;
      padding: 0 16px;
    }

    .section_main {
      margin-top: 24px;
    }

    @media (min-width: 768px) {
      .section_main {
        margin-top: 160px;
      }
    }

    .section__bg-503 {
      position: absolute;
      top: -72px;
      left: -214px;
      width: 502px;
    }

    @media (min-width: 768px) {
      .section__bg-503 {
        top: -210px;
        left: -273px;
      }
    }

    @media (min-width: 1440px) {
      .section__bg-503 {
        left: -440px;
      }
    }

    .section__title {
      font-size: 24px;
      font-weight: bold;
      margin-bottom: 16px;
    }

    @media (min-width: 768px) {
      .section__title {
        font-size: 28px;
      }
    }

    .footer {
      margin-top: 32px;
      padding: 0 16px;
    }

    .footer__title {
      margin-bottom: 8px;
    }

    .footer__link {
      display: block;
    }

  `, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
